// extracted by mini-css-extract-plugin
module.exports = {"sortButton":"DataTableSortButton_sortButton__1AMLN","sortIcon":"DataTableSortButton_sortIcon__lfHzL","arrowUp":"DataTableSortButton_arrowUp__3CcCD"};